import React, { useState, useContext } from "react";
import AnimationSpinner from "../../AnimationSpinner";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

const CreateCampaign = () => {
	const { setSelectedMethod, selectedMethod } = useContext(AppContext);
	const navigate = useNavigate();

	const methods = [
		{ label: "Search for a video", value: "search" },
		{ label: "YouTube Videos", value: "youtube" },
		{ label: "Vimeo Videos", value: "vimeo" },
		{ label: "Direct Upload", value: "upload" },
	];

	const handleMethodChange = (method) => {
		setSelectedMethod(method.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		navigate(`/ai-video-clone/${selectedMethod}`);
	};

	return (
		<div className="right-container">
			<AnimationSpinner show={false} />
			<div className="container h-75">
				<div className="row h-100  mt-4 justify-content-center align-items-center form_styled_wrap">
					<div className="col-lg-6 col-md-8 col-sm-10 col-12">
						<div className="campaign-glass-card stylish-card p-4">
							<h2 className="campaign-title mb-3">🎯 Create A New Campaign</h2>
							<p className="campaign-subtitle mb-4">
								Select your preferred method below:
							</p>

							<form onSubmit={handleSubmit} className="campaign-method-form">
								{methods.map((method, index) => (
									<div
										key={method.value}
										className={`method-box ${
											selectedMethod === method.value ? "active" : ""
										}`}
										onClick={() => handleMethodChange(method)}
									>
										<label
											htmlFor={`method-${method.id}`}
											className="method-label"
										>
											<span className="method-index">{index + 1}.</span>{" "}
											{method.label}
										</label>
										<input
											type="radio"
											name="method"
											id={`method-${method.id}`}
											checked={
												method.value === "search" ||
												selectedMethod === method.value
											}
											onChange={() => handleMethodChange(method)}
										/>
									</div>
								))}
								<div className="d-flex justify-content-end">
									<button type="submit" className="btn btn-submit">
										Continue <IoIosArrowForward />
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateCampaign;
